/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { RefObject, useMemo, useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "quill-image-uploader/dist/quill.imageUploader.min.css";

type TextAreaProps = {
    value?: string;
    onChange?: (value: string) => void;
};

const TextArea = (props: TextAreaProps) => {
    const { value, onChange } = props;

    const QuillRef = useRef<ReactQuill>(null);

    const useQuill = (quillRef: RefObject<ReactQuill>) => {
        return useMemo(() => {
            return {
                toolbar: {
                    container: [["bold"]],
                },
            };
        }, [quillRef]);
    };

    const modules = useQuill(QuillRef);

    return (
        <ReactQuill
            ref={QuillRef}
            modules={modules}
            value={value}
            onChange={onChange}
            css={css`
                width: 100%;
                height: 100px;
            `}
        />
    );
};

export default TextArea;
